import React, { useState } from "react"
import { Redirect } from "react-router-dom"
import GlobalHelper from "../common/GlobalHelper.jsx"
import EditAndRefundCreditMemoModal from "../invoice/editandrefundcreditmemomodal.component.jsx"

type OwnProps = {
    creditMemoId: string,
    contactId: string,
    creditMemoIdentifier: string
}

const CreditMemoModalLink = (props: OwnProps) => {
    const [showModal, setShowModal] = useState(false)
    const [redirect, setRedirect] = useState({
        redirect: false,
        objectId: "",
        objectType: "",
    })

    return (
        <span>
            {
                showModal &&
                <EditAndRefundCreditMemoModal
                    creditMemoId={props.creditMemoId}
                    readOnly={false}
                    hideDeleteButton={true}
                    contactId={props.contactId}
                    onClose={(objectId, objectType) => {
                        setShowModal(false)
                        if (objectId) {
                            setRedirect({
                                redirect: true,
                                objectId: objectId,
                                objectType: objectType,
                            })
                        }
                    }}
                />
            }
            {
                redirect.redirect &&
                <Redirect to={{ pathname: GlobalHelper.getObjectEditPathByObjectType(redirect.objectId, redirect.objectType) }}>
                </Redirect>
            }
            <a href="#" onClick={(e) => {
                e.preventDefault()
                setShowModal(!showModal)
            }}>
                {props.creditMemoIdentifier}
            </a>
        </span>
    )

}

export default CreditMemoModalLink


// WEBPACK FOOTER //
// ./src/invoice/creditmemomodallink.component.tsx